export default "/images/table_placeholder.png?7dd04554b017ed0f5af2fe88ff79fe71";